import {h, Fragment} from "preact"
export default function StarRating({ ratingValue, reviewCount }) {
    const maxStars = 5;


    const fullStar = (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="star-icon full-star"
        >
            <path d="M12 .587l3.668 7.568L24 9.423l-6 5.847 1.418 8.267L12 18.896l-7.418 4.641L6 15.27 0 9.423l8.332-1.268z" />
        </svg>
    );

    const emptyStar = (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            className="star-icon empty-star"
        >
            <path d="M12 .587l3.668 7.568L24 9.423l-6 5.847 1.418 8.267L12 18.896l-7.418 4.641L6 15.27 0 9.423l8.332-1.268z" />
        </svg>
    );

    const halfStar = (
        <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 510 510"
            className="star-icon half-star"
        >
            <g>
                <g id="star-half">
                    <path d="M510,197.472l-183.37-15.734L255,12.75l-71.629,168.988L0,197.472l0,0l0,0l139.103,120.539L97.41,497.25L255,402.186l0,0 l157.59,95.039l-41.692-179.239L510,197.472z M255,354.348V117.172l43.605,102.918l111.689,9.588l-84.711,73.389l25.398,109.166 L255,354.348z" />
                </g>
            </g>
        </svg>
    );


    const stars = Array.from({ length: maxStars }, (_, i) => {
        if (i < Math.floor(ratingValue)) {
            return <span key={i} className="star">{fullStar}</span>;
        } else if (i < Math.ceil(ratingValue)) {
            return <span key={i} className="star">{halfStar}</span>;
        } else {
            return <span key={i} className="star">{emptyStar}</span>;
        }
    });

    return (
        <>
            {reviewCount > 0 && (<div className="star-rating">
                <div className="star-container">{stars}</div>
                <span className="review-count">({reviewCount})</span>
            </div>)}
        </>

    );
}
